module.exports = __webpack_public_path__ + "static/media/wheretorun_4.a1c391ba.png";